export const locationFlags = {
  Dubai: "🇦🇪",
  Germany: "🇩🇪",
  Switzerland: "🇨🇭",
};
